import { useSelector } from 'react-redux';

import { CourseProgressState } from '../redux/slice/user-course';
import { RootState } from '../redux/store';

export const useCourseProgressContext = (): CourseProgressState => {
  const state: CourseProgressState = useSelector((state: RootState) => state.courseProgress);
  return state;
};
